import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"

import { ImageWithTeaserBox } from "gatsby-theme-gba"

const ImageWithTeaserBoxEditable = ({ blok }) => {
  const { file, allFile } = useStaticQuery(graphql`
    query ImageWithTeaserBoxExampleQuery {
      file(relativePath: { eq: "image-with-teaser-box.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      allFile(filter: { id: { regex: "/(?:.*)imageWithTeaserBox/" } }) {
        edges {
          node {
            id
            name
            childImageSharp {
              gatsbyImageData(quality: 80, layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  `)

  let filteredFiles = allFile.edges.filter(function (projectFile) {
    if (!blok.image || !projectFile.node.id.includes(blok.image.substring(1))) {
      return false // skip
    }

    return true
  })

  let imageFile = filteredFiles[0]
    ? getImage(filteredFiles[0].node)
    : blok.image

  const link =
    blok.link.url || blok.link.cached_url
      ? blok.link.linktype === "story"
        ? blok.link.id
        : blok.link.url
      : "/home"

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <ImageWithTeaserBox
        heading={blok.heading || "Headline"}
        subHeading={blok.subHeading || "Sub Headline"}
        headlineName={blok.headlineName}
        link={link}
        buttonText={blok.linkText}
        linkTarget={blok.linkTarget}
        image={imageFile || file.childImageSharp.gatsbyImageData}
        imageAlt={blok.imageAlt}
        download={blok.link && blok.link.linktype === "asset"}
        orientation={blok.orientation}
        mode={blok.mode}
        currentLanguage={blok.currentLanguage}
        disableHyphens={blok.disableHyphens}
      />
    </div>
  )
}

export default ImageWithTeaserBoxEditable
